import React, { useEffect, useState } from 'react';

import moment from 'moment';
import ChartMetering from '../../../components/chart/ChartMetering';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage';
import CardMeterGrid from '../../../components/card/CardMeterGrid';
import CardMeterSolar from '../../../components/card/CardMeterSolar';
import ScrollToTopButton from '../../../components/extra/ScrollToTopButton.js';

function MeasurementMetering(props) {
    const [data_chart, setData_chart] = useState({
        XLabel: '',
        Data: [],
        Summary: {},
        CODData: {},
    });
    const [chart_plot, setChart_plot] = useState({
        XLabel: '',
        Power: [],
        IRR: [],
        Color: '#2ECC71'
    });

    const [meter_selected, setMeter_selected] = useState({
        type: '',
        meter_id: '',
        datakey: '',
        data: {}
    });

    const [data_metergrid, setData_metergrid] = useState({});
    const [data_metersolar, setData_metersolar] = useState([]);

    useEffect(() => {
        return () => {
            setData_chart({})
            setChart_plot({})
            setMeter_selected({})
            setData_metergrid({})
            setData_metersolar([])
        };
    }, []);

    useEffect(() => {
        if (props.data_metergrid !== null) {
            setData_metergrid(props.data_metergrid)
        }
    }, [props.data_metergrid]);

    useEffect(() => {
        if (props.data_metersolar !== null) {
            setData_metersolar(props.data_metersolar)
        }
    }, [props.data_metersolar]);

    useEffect(() => {
        if (props.data_chart !== null && props.data_chart !== undefined) {
            if (props.data_chart.chart_5m !== null && props.data_chart.chart_5m !== undefined) {
                if (props.data_chart.chart_5m.Data !== null) {
                    setData_chart(props.data_chart.chart_5m)
                }
            }
        }
    }, [props.data_chart]);

    useEffect(() => {
        if (data_chart.Data.length > 0 && meter_selected.type !== '' && meter_selected.meter_id !== '') {
            let arr1 = []
            let arr2 = []
            let color = '#2ECC71'
            if (meter_selected.meter_id === 'Grid Meter') {
                color = "#E74C3C"
            }
            for (let i = 0; i < data_chart.Data.length; i++) {
                const dx = new Date(data_chart.Data[i].x)

                arr1.push({ x: dx, y: data_chart.Data[i].irr })
                arr2.push({ x: dx, y: data_chart.Data[i][meter_selected.datakey] })
            }
            setChart_plot({
                IRR: arr1,
                Power: arr2,
                XLabel: data_chart.XLabel,
                Color: color
            })
        } else {
            setChart_plot({
                IRR: [],
                Power: [],
                XLabel: '',
                Color: ''
            })
        }
    }, [data_chart, meter_selected]);

    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });
    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    function PopupMsg_onConfirm(confirmcode) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    function getMeterIcon(data, type) {
        if (type === "Grid Meter") {
            if (data.connection_logger !== undefined) {
                if (data.connection_logger === true) {
                    if (data.connection_device === true) {
                        return <h5 className="card-title font-weight-bold mb-0"> Grid Meter <span className='tagalarm normal'>Online</span></h5>
                    } else {
                        return <h5 className="card-title font-weight-bold mb-0"> Grid Meter <span className='tagalarm alarming'>Device Offline</span></h5>
                    }
                } else {
                    return <h5 className="card-title font-weight-bold mb-0"> Grid Meter <span className='tagalarm alarming'>Logger Offline</span></h5>
                }
            } else {
                return <h5 className="card-title font-weight-bold mb-0"> Grid Meter <span className='tagalarm alarming'>Unknown Logger State</span></h5>
            }
        } else {
            if (data.connection_device !== undefined) {
                if (data.connection_device === true) {
                    return <h5 className="card-title font-weight-bold mb-0"> {data.meter_id_text} <span className='tagalarm normal'>Online</span></h5>
                } else {
                    return <h5 className="card-title font-weight-bold mb-0"> {data.meter_id_text} <span className='tagalarm alarming'>Device Offline</span></h5>
                }
            } else {
                return <h5 className="card-title font-weight-bold mb-0"> {data.meter_id_text} <span className='tagalarm alarming'>Unknown Device State</span></h5>
            }
        }
    }

    function ReadTags_SerialNoSubSystem(data) {
        if (data !== undefined) {
            if (data.serial_no !== undefined) {
                if (data.solar_type !== undefined && data.solar_type !== "") {
                    return <h6 className="mt-0 mb-0">Serial No. : {data.serial_no}, {data.solar_type}</h6>
                } else {
                    return <h6 className="mt-0 mb-0">Serial No. : {data.serial_no}</h6>
                }
            } else {
                return null
            }
        } else {
            return null
        }
    }

    function ReadTags_String(data) {
        if (data !== undefined) {
            return "Update : " + data
        } else {
            return "Update : -"
        }
    }

    function BackCenter() {
        if (props.permitdata !== null && props.permitdata !== undefined) {
            if (props.permitdata.user_mode !== null && props.permitdata.user_mode !== undefined) {
                if (props.permitdata.user_mode === "center") {
                    return <button className='back-center-btn' onClick={() => {
                        props.callback_backcenter()
                    }}>Back to Center</button>
                }
            }
        }
    }

    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="mdi mdi-speedometer color-orange"></i> Metering</h4>
                                    <p className="mb-1">Energy Meter monitoring</p>
                                    <h6 className='mb-0'><i className="mdi mdi-clock-time-four-outline"></i> Update : {props.server_update !== "-" ? moment(new Date(props.server_update)).format("YYYY-MM-DD HH:mm:ss") : "Unknown"}</h6>
                                </div>
                                <div>
                                    {BackCenter()}
                                </div>
                            </div>
                            <hr className="new-section-xs mb-2" />
                        </div>
                    </div>

                    <div className="row">
                        <div className='d-flex flex-wrap'>
                            <CardMeterGrid
                                data={data_metergrid}
                                onClick={setMeter_selected}
                            />
                            {
                                data_metersolar !== undefined ?
                                    data_metersolar.map((meter, index) => (
                                        <CardMeterSolar
                                            key={index}
                                            data={meter}
                                            onClick={setMeter_selected}
                                        />
                                    ))
                                    :
                                    null
                            }
                        </div>
                    </div>

                </div>
            </div>

            {
                meter_selected.meter_id !== "" ?
                    <div className='modal-overlay'>
                        <div className="modal d-block" >
                            <div className={"modal-dialog  modal-dialog-centered px-2 " + (window.screen.width < 1200 ? "modal-xxl" : "modal-xl")}>
                                <div className="modal-content">
                                    <div className="modal-body pt-0 modal-popup-inverter px-0">
                                        <div className="card shadow-none">
                                            <div className="card-header">
                                                <div className='d-block'>
                                                    <div className="d-flex mt-0 mb-0">
                                                        {getMeterIcon(meter_selected.data, meter_selected.type)}
                                                    </div>
                                                    {ReadTags_SerialNoSubSystem(meter_selected.data)}
                                                    <p className="update-time mt-0 mb-0">{ReadTags_String(meter_selected.data.update_time)}</p>
                                                </div>
                                            </div>
                                            <div className="card-body pt-1 pb-1">
                                                <ChartMetering
                                                    solorpower={chart_plot.Power}
                                                    irr={chart_plot.IRR}
                                                    xlabel={chart_plot.XLabel}
                                                    chart_style={chart_plot.Chart1_Style}
                                                    color={chart_plot.Color}
                                                ></ChartMetering>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-light"
                                            onClick={() => {
                                                setMeter_selected({
                                                    type: '',
                                                    meter_id: '',
                                                    datakey: '',
                                                    data: {}
                                                });
                                                setChart_plot({
                                                    ...chart_plot,
                                                    IRR: [],
                                                    Power: [],
                                                    Color: ''
                                                })

                                            }}>Close</button>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                    :
                    null
            }
            <ScrollToTopButton />
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onConfirm={PopupMsg_onConfirm} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}
export default MeasurementMetering